import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AcmicService } from "../../../_services/acmic.service";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'mapfre-icon',
  templateUrl: './mapfre-icon.component.html'
})
export class MapfreIconComponent implements OnInit {
  @Input() iconClasses:                       string;
  @Input() iconFamily:                        string;
  @Input() alertType:                        string;
  @Input() header = false;
  @Input() title = false;
  @Input() showWanringIcon = false;
  @Input() loginPageIcon = false;
  @Input() password:                          boolean;
  @Input() passwordShow = false;
  @Input() focusShowIcon = false;
  @Input() showIconsForPassword:              boolean;
           screenReaderText = 'SHOW_PASSWORD';
  
  @Output() clickShowPassword = new EventEmitter<boolean>();
  isAcmic: boolean;
  showPasswordFunction(): void {
    this.passwordShow = !this.passwordShow;
    this.clickShowPassword.emit(this.passwordShow);
  }
  
  constructor(private acmicService: AcmicService) {
    this.isAcmic = false;
   }   

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
  }

}
